exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/_wks-ext.js
// module id = 153
// module chunks = 1